export enum ParseUniversalInvoiceMethodEnum {
  /** Processing a file using a neural network */
  GPT = 'GPT',
  /** Processing a file using an custom algorithm Node.js (bad idea) */
  NODE = 'NODE',
}